<template>
    <div class="my-panel">
        <div class="my-panel__hd">
            <h3>王者财经账号区</h3>
        </div>
        <div class="my-panel__bd panel_style ">
            <div  class="">
                <div class="fts-30 ta-center">您的账号等级:</div>
                <k-hr size="20" />
                <van-row type="flex" gutter="10">
                    <van-col span="5"></van-col>
                    <van-col span="4">
                        <img :src="myLogo" alt="" class="my-logo"> 
                    </van-col>
                    <van-col span="10">
                        <div>{{myNick}}</div>
                        <span v-if="powerInfo" class="fts-24 cl-yel">当前身份:{{powerInfo.name}}</span>
                    </van-col>
                </van-row>
                
            </div>             
            <template v-if="powerInfo">
                <k-hr size="50" />
                <van-row  v-if="powerInfo && powerInfo.stage<2">
                    <van-col span="24" class="ta-center">距离黄金还差：{{leftExp}}</van-col>
                    <van-col span="5" class="fts-34">草根值</van-col>
                    <van-col span="19">
                         <k-hr size="20" />
                        <div>                        
                        <van-progress :percentage="ratio" :pivot-text="''+myExp" color="#ee0a24" stroke-width="8" />
                        <k-hr size="20" />
                        <van-row class="fts-24">
                            <van-col span="10">0</van-col>
                            <van-col span="14" class="ta-right">10000<br>终身黄金</van-col>
                        </van-row>
                        </div>
                    </van-col>
                </van-row>                
                <div v-else class="ta-center">
                    恭喜您已获得：
                    终身{{powerInfo.name}}会员<br>
                    当前草根值：{{powerInfo.exp || 0}}
                </div>
            </template>
            <br>
            <div class="ta-center">
                <van-button type="danger" x-click="go.login">切换账号</van-button>
            </div>
        </div>
        
        
    </div>
</template>
<script>
    import {mapActions, mapGetters, mapState} from 'vuex'
    export default {
        data() {
            return {
                maxExp : 10000
            }
        },
        computed: {
            ...mapGetters(['myUid', 'myLogo', 'myNick']),
            ...mapState('exp', ['powerInfo','thisLevel','nextLevel','myExp']),
            ratio(){
                if(this.myExp){
                    if(this.myExp >= this.maxExp){
                        return 100
                    }
                    return this.myExp/this.maxExp*100
                }
                return 0
            },
            leftExp(){
                if(this.myExp){
                    if(this.maxExp - this.myExp <= 0){
                        return '已达到'
                    }
                    return (this.maxExp - this.myExp).toFixed(2)
                }
                return 0
            }
        },
    }
</script>